import { defineSlotRecipe } from '@chakra-ui/react/styled-system';

const groupHeadingRecipe = defineSlotRecipe({
  className: 'group-heading',
  slots: ['root', 'titleBlock', 'icon', 'label', 'separator'],
  base: {
    root: {
      alignItems: 'center',
      display: 'flex',
      gap: '16',
      overflow: 'clip',
      paddingBlockEnd: '4',
      paddingBlockStart: '8',
      paddingInlineEnd: '8',
    },
    titleBlock: {
      alignItems: 'center',
      display: 'flex',
      flexShrink: 0,
      gap: '4',
    },
    icon: {
      color: 'icon/tertiary',
      flexShrink: 0,
    },
    label: {
      color: 'text/tertiary',
      flexShrink: 0,
      textStyle: 'heading/h6',
    },
    separator: {
      // Lighter than the shared `Separator` recipe's `border/regular`, and that difference is in the
      // design: Figma's general Separator component (`62:701`) is `border/regular` #dfdae1, while the
      // Page sidebar's group header (`20014:6508`) draws its rule in `border/minimal` #efebef. A rule
      // that trails a label is quieter than one that stands alone.
      //
      // It sits here rather than in the sidebar so every group heading matches — the select menu's
      // group labels included. They render this same component, so a heading looks the same wherever
      // it appears instead of the sidebar owning a private variant. It stays `border/minimal` at
      // every breakpoint.
      borderColor: 'border/minimal',
      flex: 1,
    },
  },
});

export default groupHeadingRecipe;
